import React, {
  RefObject,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import Button from "../../../../views/buttons/Button";
import Card from "../../../../views/cardwrapper/Card";
import Img from "../../../../assets/img/hotel-image.png";
import BeLogoImage from "../../../../assets/img/booking_engine_logo_placeholder.png"
import { toast } from "react-toastify";
import { dispatch } from "d3";
import { useDispatch, useSelector } from "react-redux";
import kernelApi from "../../../../API/kernelApi";
import {
  ShowConfirmationPrompt,
  CancelConfirmationPrompt,
  DisableSwitchPropertyScreen,
} from "../../../../redux/actions/PromptAction";
import { RootState } from "../../../../redux/store";
import { useNavigate } from "react-router";
import beApi from "../../../../API/beApi";
import Loader from "../../../../views/loader/Loader";
import { CATCH_MESSAGE, Logout } from "../../../../UtilityFunctions";
import { url } from "inspector";

const Logo = () => {
  const defaultImg = "data:image/svg+xml;base64,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"



  const { current_property } = useSelector(
    (state: RootState) => state.properties
  );
  const { admin_id, auth_token, company_id } = useSelector(
    (state: RootState) => state.auth
  );
  const { accessData, adminAcess } = useSelector(
    (state: RootState) => state.userAcess
  );
  // private readonly inputLogo : RefObject<HTMLInputElement>;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const inputLogo: RefObject<HTMLInputElement> = React.createRef();
  const inputBanner: RefObject<HTMLInputElement> = React.createRef();

  const [loader, setLoader] = useState<boolean>(false);
  const [logo, setLogo] = useState<any>();
  const [banner, setBanner] = useState<any>();
  const [logoBannerImages, setLogoBannerImages] = useState<any[]>([]);
  const [newImages, setNewImages] = useState<any[]>([]);
  const [access, setAccess] = useState(true);
  const [fetchedIMAGE, setFetchedIMAGE] = useState('');
  const [selectedIMAGE, setSelectedIMAGE] = useState<any[]>([]);

  // const uploadImageFile = () => {
  //   document.getElementById("upload-images")?.click();
  // };

  // Check if user has access to this page
  useEffect(() => {
    const status = accessData.filter((iteam) => {
      return iteam?.code === "BE";
    })[0]?.access_value;
    adminAcess === 911
      ? setAccess(true)
      : status === 1
        ? setAccess(true)
        : setAccess(false);
  }, [accessData, adminAcess]);

  const getSrcFromImage = (image: any, index: number) => {
    if (!image) return
    try {
      return URL.createObjectURL(image);
    }
    catch (error) {
      let images = [...newImages];
      images.splice(index, 1);
      setNewImages(images);
    }
  };

  const getIMG = async () => {
    try {
      // const resp = await kernelApi.get(`/company_profile/logo/${company_id}`)
      const resp = await kernelApi.get(`/company_profile/logo/${company_id}`)
      if (resp.data.status === 1) {
        const { image_id, image_name } = resp.data.data
        setFetchedIMAGE(image_name)
      }
    }
    catch { }
  }

  useEffect(() => { getIMG() }, [])

  const onImageSelect = (event: any) => {
    let Images = [...selectedIMAGE];
    for (
      let file = 0;
      file < event.target.files.length;
      file++
    ) {
      let image = event.target.files[file];
      if (image.size < 1024 * 1024) {
        // file size is less than 1 MB
        Images[0] = image;
      }
      else {
        toast("Image size should be less than 1 MB", {
          hideProgressBar: true,
          type: "error",
        });
      }
    }
    setSelectedIMAGE(Images)
  };


  // Get Logo and Banner Images
  const getLogoBannerImages = async () => {
    setLoader(true);
    try {
      let res = await kernelApi.get(
        // "/hotel_admin/get_exterior_images/" + current_property.hotel_id
        `/company_profile/get-logo/${company_id}`
      );
      if (res.data.status === 1) {
        setLogoBannerImages(res.data.data);
        setLoader(false);
      } else {
        setLogoBannerImages([]);
        setLoader(false);
      }
    } catch (error: any) {
      setLogoBannerImages([]);
      setLoader(false);
      if (error.response.status === 400) {
        Logout();
      }
    }
    dispatch(DisableSwitchPropertyScreen());
  };

  useEffect(() => {
    getLogoBannerImages();
  }, [current_property]);

  // Upload Image Handler
  const uploadLogoImages = async () => {
    // setLoader(true);
    // if (newImages.length > 0) {
    if (selectedIMAGE.length > 0) {
      let payload = new FormData();
      payload.append("hotel_id", current_property.hotel_id);
      // payload.append(
      //   "existing_images_ids",
      //   currentRoomTypeDetails.room_type_images_ids.join(",")
      // );
      // newImages.forEach((image: any) => {
      selectedIMAGE.forEach((image: any) => {
        payload.append("uploadFile[]", image);
      });

      try {
        setLoader(true);
        let response = await kernelApi.post(
          `/upload/${current_property.hotel_id}`,
          payload,
          {
            headers: {
              Authorization: "Bearer " + auth_token,
            },
          }
        );
        if (response.data.status === 1) {
          setTimeout(getLogoBannerImages, 0); // sohuld be delayed
          const { message, image_ids, home_url } = response.data;
          toast(message, {
            hideProgressBar: true,
            type: "success",
          });
          setNewImages([]);
          const logoId = image_ids[0];
          // const bannerId = image_ids.splice(0, 1);
          imageIdSendHandler(logoId, home_url);
          setLoader(false);
          // setSelectedIMAGE([])
        }
        else {
          toast(response.data.message, {
            hideProgressBar: true,
            type: "error",
          });
          setLoader(false);
        }
        // setOpenSlideEditRoomType(false);
      }
      catch (error) {
        toast(CATCH_MESSAGE, {
          hideProgressBar: true,
          type: "error",
        });
        setLoader(false);
      }
    }
  };

  // Api Call For Image Id Send
  const imageIdSendHandler = async (
    logoId: any,
    home_url: any
  ) => {
    setLoader(true);
    const obj = {
      home_url: home_url,
      logo: logoId.toString(),
      banner: '',
    };
    const payload = new FormData();
    const blob = new Blob([JSON.stringify(obj, null, 2)], {
      type: "application/json",
    });
    payload.append("data", blob);
    try {
      let req = await kernelApi.post(
        `/company_profile/booking_page/${company_id}`,
        obj,
        {
          headers: {
            Authorization: "Bearer " + auth_token,
          },
        }
      );
      if (req.data.status === 1) {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
    }
  };

  const deleteImage = (image_id: number) => {
    dispatch(
      ShowConfirmationPrompt(
        "Are you sure you want to delete this image?",
        "DELETE",
        async () => {
          setLoader(true);
          try {
            let res = await kernelApi.post(`/deleteImage`, {
              imageId: image_id,
              hotel_id: current_property.hotel_id,
              type: "exterior_image",
            });
            if (res.data.status === 1) {
              toast(res.data.message, {
                hideProgressBar: true,
                type: "success",
              });
              getLogoBannerImages();
              setLoader(false);
            } else {
              toast(res.data.message, {
                hideProgressBar: true,
                type: "error",
              });
              setLoader(false);
            }
          } catch (error: any) {
            toast(CATCH_MESSAGE, {
              hideProgressBar: true,
              type: "error",
            });
            setLoader(false);
            if (error.response.status === 400) {
              Logout();
            }
          }
          dispatch(CancelConfirmationPrompt());
        }
      )
    );
  };

  const logoUploadHandler = () => {
    const { current } = inputLogo;
    (current || { click: () => { } }).click();
  };

  const bannerUploadHandler = useCallback(() => {
    const { current } = inputBanner;
    (current || { click: () => { } }).click();
  }, [inputBanner]);

  return (
    <>
      {loader ? (
        <div className="loader-setup">
          <Loader />
        </div>
      ) : (
        <>
          <Card className="d-flex flex-row justify-content-between">
            <div className="col-5 bkng-engn-logo">
              <div className="d-flex flex-row align-items-center justify-content-start">
                <div className="logo-input-field me-4">

                  <input
                    id="logo-upload"
                    ref={inputLogo}
                    type="file"
                    accept="image/png, image/jpeg, image/jpg"
                    style={{ display: "none" }}
                    onChange={onImageSelect}
                  />

                  <div className="logo__wrapper" style={{ backgroundImage: fetchedIMAGE ? 'none' : `url(${defaultImg})` }}>
                    {/* {newImages?.map((image, index) => { */}
                    {/* if (index === newImages.length - 1) { */}
                    {/* return ( */}
                    <img
                      className="property--image--radius"
                      // src={getSrcFromImage(image, 0)}
                      // src={fetchedIMAGE}
                      src={getSrcFromImage(selectedIMAGE[0], 0) ? getSrcFromImage(selectedIMAGE[0], 0) : fetchedIMAGE}
                      alt={""}
                    />
                    {/* ) */}
                    {/* } */}
                    {/* }) */}
                    {/* } */}
                  </div>

                </div>
                <div>
                  <Button
                    icon="bi bi-upload"
                    handleClick={() => {
                      logoUploadHandler();
                    }}
                    isAccessible={access}
                  >
                    Browse
                  </Button>
                </div>
              </div>
            </div>
            <div className="col-2 vrtcl-hr--line"></div>
            <div className="bkng-engn-logo important-div-wrapper">
              <div className="col">
                <div className="imp-notes">Important Notes</div>
                <div className="mt-4">
                  <p className="img-condn">
                    1. Logo dimensions should not be exceed more than 510 &#x2715;
                    298 pixels{" "}
                  </p>
                  <p className="img-condn">
                    2. Logo size should not be exceed more than 1MB
                  </p>
                </div>
              </div>
            </div>
          </Card>
          <div className="save-btn mt-4 pt-2">
            <Button
              handleClick={() => {
                uploadLogoImages();
              }}
              loader={loader}
              isAccessible={access}
            >
              Upload
            </Button>
          </div>
        </>
      )}
    </>
  );
};

export default Logo;

